<script setup>
import {
    defineProps,
    onMounted,
    ref,
    defineExpose,
    watch,
    computed,
    nextTick,
    inject,
    onUnmounted,
    defineEmits
} from 'vue';
import i18n from "@/i18n"
import myDailog from '../../common/myDailog.vue';
import { sankey1Chart, drawRadar, clearChart } from "@/utils/chart.js"
import { useRoute } from 'vue-router';
import { sankey_v3, getFileUrl, } from "@/service"
import { getDashboardDigital_passport_database, get_dashboarddigital_passport_database_detail } from "@/service/apiList/dashboard"
import { showMessage } from "@/utils/hooks/message"
import PreviewImg from "@/components/common/PreviewImg";
import moment from 'moment';
// import dataJson from "@/utils/test"
import { getLangValue, makeQrCode, getNewline } from "@/utils/common"; //获取后端语言
const props = defineProps({
    title: {
        type: String,
        required: true,
        default: '数字护照：质量'
    },
    title1: {
        type: String,
        required: true,
        default: getLangValue('dashboard.quality.titleText5_new')
    },
    title2: {
        type: String,
        required: true,
        default: getLangValue('dashboard.quality.special_functional_indicators')
    },
    // 第一层数据
    databaseList: {
        type: Array,
        required: true,
        default: () => []
    },
    placeholder: {
        type: String,
        required: true,
        default: ''
    },
    category: {
        type: String,
        required: true,
        default: '3'
    }
})
const showPreviewImg = ref(false)
const route = useRoute()
const myChartsRef = ref(null)
let resizemychart1Ob = null // mychart 振动 动态监听
const emits = defineEmits(['updatePage',])
const detailInfo = ref({})
const srcList = ref([])
// const selectedIndex = ref(0)
const product_template_name = ref([])
const hscode = ref('')
const hscode_title = ref('')
const hscodeList = ref([])
const keyword = ref('')
const order_by = ref('desc')
const sort_field = ref('total_value')
const indicator_standard_list = ref([]) //特殊指标list
const hscodeListStr = computed(() => JSON.stringify(props.databaseList))
// const selectedHscodeList = ref()
const imageList = ref([])
const visible = ref(false)
const productList = inject('productList')
const productList_total = inject('productList_total')
const selectedIndex = inject('selectedIndex')
const selectedProductId = inject('selectedProductId')
const nodeDataList = ref([]) // 展示桑基图产品对应的pid
const searchInfo = ref({
    page: 1,
    limit: 10,
    keyword: '',
})
// const selectedData = inject('selectedData')
// // 获取所选 hscode 
// const getSelectedHscodeList = () => {
//     selectedHscodeList.value = props.hscodeList[selectedIndex.value].children
// }
const showInstand = ref(true) // 显示指标
const ragarOption = ref({}) // 当前显示radar图
const sankeyOption = ref({}) // 当前显示桑吉图
const title = ref('') // 标题信息
const radarHasData = ref(false)
const loadingSankey = ref(false) // 桑基图加载效果
const loadingRadar = inject('loadingRadar') // 雷达图加载效果
// const setPidName = () => {
//     // pid 这里名称需要切换
//     switch (props.category) {
//         case 3:
//             return 'PID'
//         case 5:
//             return 'GTIN'
//         default:
//             return 'PID'
//     }
// }
const getNameByCategory = (type = 1) => {
    if (type == 1) {
        switch (props.category) {
            case 3:
                return getLangValue('dashboard.quality.quality_traceability_diagram')
            case 5:
                return getLangValue('dashboard.environment.quality_traceability_diagram')
            case 6:
                return getLangValue('dashboard.esg.quality_traceability_diagram')
            case 4:
                return getLangValue('dashboard.circularity.quality_traceability_diagram')
            case 2:
                return getLangValue('dashboard.comfort.quality_traceability_diagram')
            case 1:
                return getLangValue('dashboard.traceability.quality_traceability_diagram')
            default:
                return getLangValue('dashboard.quality.quality_traceability_diagram')
        }
    } else {
        return props.title1
    }

}
const fieldsList = ref([
    {
        name: 'HS Code',
        key: 'title'
    },
    {
        name: getLangValue('dashboard.hScodedescription'),
        key: 'description'
    },

    {
        name: getLangValue('dashboard.supplier'),
        key: 'company_name'
    },
    {
        name: getLangValue('product-management', "code_oid"),
        key: 'oid'
    },
    {
        name: getLangValue('product-management', "code_pid_gtin"),
        key: 'pid'
    },

    {
        name: getLangValue('dashboard.batchtotalquantity'),
        key: 'batch_size'
    },
    {
        name: getLangValue('dashboard.listingTime'),
        key: 'release_time',
        showChart: true
    },
    {
        name: getLangValue('product-template.origin'),
        key: 'place_of_origin',
        showChart: true
    },
    {
        name: getLangValue('product-template.targetmarket'),
        key: 'targetmarket',
        showChart: true
    },
    {
        name: getLangValue('product-template.size'),
        key: 'size',
        showChart: true
    },
    {
        name: getLangValue('product-template.color'),
        key: 'color',
        showChart: true
    },
])

// const chartsFieldList = ref([
//     // {
//     //     name: getLangValue('dashboard.batchtotalquantity'),
//     //     key: 'batch_size'
//     // },
//     // {
//     //     name: getLangValue('dashboard.listingTime'),
//     //     key: 'release_time',
//     //     showChart: true
//     // },
//     // {
//     //     name: getLangValue('product-template.origin'),
//     //     key: 'place_of_origin',
//     //     showChart: true
//     // },
//     // {
//     //     name: getLangValue('product-template.targetmarket'),
//     //     key: 'targetmarket',
//     //     showChart: true
//     // },
//     // {
//     //     name: getLangValue('product-template.targetmarket'),
//     //     key: 'targetmarket',
//     //     showChart: true
//     // },
//     // {
//     //     name: getLangValue('product-template.targetmarket'),
//     //     key: 'targetmarket',
//     //     showChart: true
//     // },
// ])
// const rankValueList = ref([0, 0])
const qrcode = async (id = '') => {
    // console.log(id);
    if (!id && !detailInfo.value.pid && !detailInfo.value.organization && !detailInfo.value.organization.oid) return
    // 根据详细信息
    const reps = await makeQrCode({ type: 2, id: id })
    if (reps) {
        imageList.value.push(reps);
    }
    // 组织机构信息
    const reps1 = await makeQrCode({ type: 1, id: detailInfo.value.organization?.id })
    if (reps) {
        imageList.value.push(reps1);
    }
}
const showChart = async (type = 'normal') => {
    //展示图表信息  normal 弹窗大图  samall 小图
    // 展示图表
    if (!detailInfo.value.organization || !detailInfo.value.organization.table_name || !detailInfo.value.id) {
        showMessage('info', getLangValue('base.no_data'))
        return
    }
    let params = {
        table_name: detailInfo.value.organization.table_name,
        database_id: detailInfo.value.id,
        category_id: props.category
    }
    // let xx = false;
    // if (xx) {
    // 如果有缓存数据 就用缓存的数据 不再掉接口
    if (sankeyOption.value?.nodes?.length && sankeyOption.value?.links?.length) {
        visible.value = type == 'normal' ? true : false
        // normal  大图
        if (type == 'normal') {
            title.value = getNameByCategory(1)
        }
        // draw 
        nextTick(() => {
            makeCharts(sankeyOption.value, type)
        })
        return
    }
    loadingSankey.value = true;
    const reps = await sankey_v3(params)
    loadingSankey.value = false;
    if (reps.code == 1) {
        showMessage('danger', reps.message)
        return
    }
    sankeyOption.value = reps.payload;
    if (reps.payload.nodes.length && reps.payload.links.length) {
        visible.value = type == 'normal' ? true : false
        if (type == 'normal') {
            title.value = getNameByCategory(1)
        }
        nextTick(() => {
            makeCharts(reps.payload, type)
        })
    } else {
        if (type == 'normal') {
            showMessage('info', getLangValue('base.no_data'))
        } else {
            // 清空图表
            clearChart(document.getElementById('small-chart')) //清除上一个桑吉图
        }
    }
    // }


    // if (dataJson.nodes.length && dataJson.links.length) {
    //     visible.value = type == 'normal' ? true : false
    //     nextTick(() => {
    //         makeCharts(dataJson, type)
    //     })
    // } else {
    //     if (type == 'normal')
    //         showMessage('info', getLangValue('base.no_data'))
    // }
}
const makeCharts = (data, type) => {
    // let attributes = {}
    // // 属性信息
    // for (const item in data.nodes) {
    //     attributes[data.nodes[item].name] = data.databases[item].pid
    // }
    // 展示对应的pid信息
    nodeDataList.value = data.nodes
    let options = {
        chartDom: type == 'normal' ? myChartsRef.value : document.getElementById('small-chart'),
        // data: reps.payload,
        data: data,
        nodeDataList: nodeDataList.value,
        databaseList: props.databaseList,
    };
    sankey1Chart(options, true, type, true, 'passport', 'value', props.category);

}
const search = () => {
    //搜索
    // emits('search', { hscode: hscode.value, keyword: keyword.value, })
    // 设置分页为1
    emits('updatePage', 1)
    getData(1);
}

const changeProduct = (key) => {
    //切换产品
    setData(productList.value[key])
}


const getData = async (index = 0) => {
    // 获取数据 index 0 代表第一次加载  1 代表搜索
    if (index < 1) {
        if (route.query.hscode) hscode.value = route.query.hscode
        if (route.query.product_template_name) product_template_name.value = route.query.product_template_name
        if (route.query.keyword) keyword.value = route.query.keyword
    }
    if (!hscode.value || !product_template_name.value) {
        showMessage('danger', getLangValue('dashboard.fillDataMessage'))
        return
    }

    let params = {
        category_id: props.category, // 质量
        // hscode_id: hscode.value != null && hscode.value != '' && hscode.value.length ? [...hscode.value].pop() : '',
        hscode_id: hscode.value,
        keyword1: keyword.value.trim().replace('FBD', ''),
        order_by: order_by.value,
        sort_field: sort_field.value,
        // product_template_name: product_template_name.value,
        page: searchInfo.value.page - 1,
        limit: searchInfo.value.limit,
        keyword2: searchInfo.value.keyword.trim(),
    }

    let xx = true
    if (xx) {
        const reps = await getDashboardDigital_passport_database(params)
        if (reps.code == 0) {
            // 获取信息 
            clearChart(document.getElementById('small-chart')) //清除上一个桑吉图
            clearChart(document.getElementById('index_standard_chart')) // 清除上一个雷达图
            if (reps.payload.data.length == 0) {
                showMessage('info', getLangValue('base.no_data'))
                detailInfo.value = {}
                indicator_standard_list.value = []
                imageList.value = []
                productList.value = []
                productList_total.value = reps.payload.total
                return false
            }
            productList.value = reps.payload.data
            productList_total.value = reps.payload.total
            if (productList.value.length) {
                let index = 0
                // if (route.query.id) {
                //     index = productList.value.findIndex(item => item.id == route.query.id)
                // }
                setData(productList.value[index])
                selectedProductId.value = productList.value[index].id
            }
            // 展示雷达图
            // drawRadarChart();
        }
    }
}

// const getSpecialInstandardData = async (id) => {
//     // 获取该产品的指标数据
//     let params = {
//         category_id: '3',
//         id: id
//     }
//     const resp = await getDashboardIndex_standard_list(params)
//     if (resp.code == 0) {
//         //判断是否有值
//         let arr = resp.payload.length? resp.payload.filter(item=> item.group_name == '特殊指标'): [];
//         indicator_standard_list.value = arr.length ? arr[0].index_standard_list: [];
//     }
// }

const setData = async (data) => {
    // 通过id查询详情
    const resp = await get_dashboarddigital_passport_database_detail({ category_id: props.category, id: data.id })
    if (resp.code == 0) {
        // 缺少数据 整合table的数据
        let data1 = {
            prcie: data.prcie,
            size: data.size,
            color: data.color,
            place_of_origin: data.production_line.place_of_origin
        }
        detailInfo.value = { ...data1, ...resp.payload }
        // 获取详情
        hscode_title.value = getHscodeTitle()
        imageList.value = []
        // 获取图片
        if (detailInfo.value['product_info']) {
            let arr = detailInfo.value['product_info'].children.filter(item => item.key == 'product_info_product_picture')
            if (arr.length > 0 && arr[0].value.length) {
                let imgStr = arr[0].value[0]
                if (imgStr)
                    getFileUrl({ attachments: imgStr }).then(resp => {
                        if (resp) {
                            imageList.value.push(resp.payload[0].url)
                            srcList.value = resp.payload
                            qrcode(data.id);
                        }
                    })
            } else {
                imageList.value = [""]
                qrcode(data.id);
            }
            // 获取特殊指标  
            // getSpecialInstandardData(data.id)
        } else {
            imageList.value = [""]
            qrcode(data.id);
        }
        sankeyOption.value = {}
        // 切换缩略雷达图
        showChart('small')
    }
}

const changeTemplate = (index) => {
    if (index == 1)
        hscode.value = ''
    if (product_template_name.value.length) {
        // console.log(type.value);
        let arr = props.databaseList.filter(item => item.value === product_template_name.value[0] && item.children.filter(item1 => item1.value === product_template_name.value[1]).length)
        if (arr.length) {
            // 获取shcode
            let arr1 = arr[0].children.filter(item => item.value === product_template_name.value[1])
            if (arr1.length) {
                hscodeList.value = arr1[0].database_template_list.map(item => {
                    return {
                        id: item.hscode?.id,
                        title: item.hscode?.title,
                        title_en: item.hscode?.title_en,
                    }
                })
            }
        }
    } else {
        hscodeList.value = []
    }
}
const getHscodeTitle = () => {
    // 获取选择hscode title
    let hscodeId = hscode.value
    let title = ''
    if (hscodeId) {
        let arr = hscodeList.value.filter(item => item.id == hscodeId)
        if (arr.length) {
            title = arr[0].title
        }
    }
    return title
}
const showPicture = () => {
    showPreviewImg.value = true
}

const drawRadarChart = (data) => {
    // console.log(data);
    /**雷达图 指标 */
    const chartDom = document.getElementById('index_standard_chart')
    if (chartDom) {
        clearChart(chartDom)
    }
    radarHasData.value = Array.isArray(data) && data.length > 0
    if (!radarHasData.value) {
        ragarOption.value = {}
        return
    }
    data.sort((a, b) => {
        // 将 name 为 "综合" 的对象排到最前面
        if (a.name === "综合" && b.name !== "综合") return -1;
        if (a.name !== "综合" && b.name === "综合") return 1;
        return 0; // 其他元素保持原始顺序
    });
    // 指标list
    let indicatorList = data.map(item => {
        return {
            name: i18n.global.locale == 'en' ? getNewline(item.name_en, 10) : getNewline(item.name, 10),
            name1: i18n.global.locale == 'en' ? item.name_en : item.name,
            max: 1,
        }
    })
    // 值
    let valueList = data.map(item => item.value)
    // 均值
    let avgValueList = data.map(item => item.avg_value)
    // console.log(valueList);
    let option = {
        tooltip: {
            trigger: 'axis',
            confine: true,
            formatter: function (params) {
                // let str = ``;
                let str = ` <div style='color: ${params.color};font-weight: bold'>${params.name}</div>`;
                for (const item in params.value) {
                    str += `<div>
                        <div style='min-width:100px; text-align:left; display:inline-block'>
                            ${indicatorList[item].name1}
                        </div>
                            :
                         <div style='min-width:100px; text-align:left; display:inline-block'>${params.value[item] == null ? '-' : params.value[item]}</div>
                    </div>`
                }
                return str
            }
        },
        grid: {
            left: -20,
            right: 0,
            bottom: 0,
            top: '3%',
            containLabel: true
        },

        radar: {
            indicator: indicatorList,
            radius: 60,
            // 设置角标颜色和样式
            axisName: {
                color: '#000', // 设置角标颜色
                fontSize: 14, // 字体大小
            },
            splitLine: { //里面四个圈线条样式
                lineStyle: {
                    color: [
                        'rgba(169,169,169, 1)',
                        'rgba(232, 236,244, 1)',
                        'rgba(232, 236,244, 1)',
                        'rgba(232, 236,244, 1)',
                        'rgba(232, 236,244, 1)',
                    ],//分别对应四个第一个对应最里面的圈
                    width: 2,
                }
            },
            axisLine: {
                lineStyle: {
                    color: "rgba(169,169,169, 1)",
                    width: 2, // 轴线宽度
                }
            },
            axisLabel: {
                show: true,
                formatter: function (value, index) {
                    // 只在最后一个角显示最大值
                    if (index === 5) {
                        return value;
                    } else {
                        return '';
                    }
                }
            }
        },
        series:
            [
                {
                    type: 'radar',
                    tooltip: {
                        trigger: 'item',
                    },
                    radarIndex: 0,
                    // areaStyle: {},
                    data: [
                        {
                            name: getLangValue('dashboard.value'),
                            value: valueList,
                            lineStyle: {
                                color: '#299CDB',
                            },

                        },
                        {
                            name: getLangValue('dashboard.avg_value'),
                            value: avgValueList,
                            lineStyle: {
                                color: '#7F7F7F',
                            },
                            itemStyle: {
                                color: '#7F7F7F'
                            },
                        },
                    ]
                },
            ]
    };
    ragarOption.value = { option, indicatorList }
    // console.log(option);
    // visible.value = true
    nextTick(() => {
        let dom = document.getElementById('index_standard_chart')
        const mychartRarda = drawRadar(dom, option,)
        // 监听容器宽度变化
        resizemychart1Ob = new ResizeObserver(() => mychartRarda.resize());
        resizemychart1Ob.observe(dom);
    })

}

const showBigChart = () => {
    //展示完整雷达图
    visible.value = true
    title.value = getNameByCategory(0)
    nextTick(() => {
        let { option, indicatorList } = ragarOption.value
        option.radar.radius = 150;
        option.radar.indicator = indicatorList.map(item => {
            return {
                name: item.name1,
                max: 1,
            }
        });
        drawRadar(myChartsRef.value, option,)
    })

}
const getDetailInfo = (key) => {
    // 获取尺寸颜色
    if (detailInfo.value.product_info) {
        let ColorInfo = detailInfo.value.product_info?.children[0]?.children?.filter(item => item.key == 'product_info_base_info_color')
        if (ColorInfo.length > 0 && key == 'color') {
            return ColorInfo[0].value
        }
        let sizeInfo = detailInfo.value.product_info?.children[0]?.children?.filter(item => item.key == 'product_info_base_info_size')
        if (sizeInfo.length > 0 && key == 'size') {
            return sizeInfo[0].value
        }
        let batchsize = detailInfo.value.product_info?.children[0]?.children?.filter(item => item.key == 'product_info_base_info_batch_size')
        if (batchsize.length > 0 && key == 'batch_size') {
            return batchsize[0].value
        }
    }
    return ''
}

const getTargetmarket = () => {
    // 获取目的市场
    if (detailInfo.value.template_info && detailInfo.value.template_info.children && detailInfo.value.template_info.children.length) {
        let obj = detailInfo.value.template_info.children.find(item => item.key == 'template_info_destination_market')
        if (obj) {
            return i18n.global.locale == 'en' ? obj.value_en : obj.value
        }
    }
    return ''
}

const getdescprtion = () => {
    // 获取描述
    if (detailInfo.value.template_info && detailInfo.value.template_info.children && detailInfo.value.template_info.children.length) {
        let obj = detailInfo.value.template_info.children.find(item => item.key == 'template_info_description')
        if (obj) {
            return i18n.global.locale == 'en' ? obj.value_en : obj.value
        }
    }
    return ''
}

const getSankeyTitle = () => {
    // 获取桑吉图标题
    switch (props.category) {
        case 3:
            return getLangValue('dashboard.quality.sankey_title')
        case 5:
            return getLangValue('dashboard.environment.sankey_title')
        case 6:
            return getLangValue('dashboard.esg.sankey_title')
        case 4:
            return getLangValue('dashboard.circularity.sankey_title')
        case 2:
            return getLangValue('dashboard.comfort.sankey_title')
        case 1:
            return getLangValue('dashboard.traceability.sankey_title')
        default:
            return getLangValue('dashboard.quality.sankey_title')
    }
}

onMounted(() => {
    // qrcode();
    // console.log(productList.value);
    getData();
    // console.log(dataJson.nodes.length);
    // drawRadarChart()
})

// 销毁
onUnmounted(() => {
    if (resizemychart1Ob) {
        // console.log('销毁振动..');
        resizemychart1Ob.disconnect();
    }
})

watch(hscodeListStr, () => {
    changeTemplate(0);
})

watch(selectedIndex, (val) => {
    changeProduct(val)
})

watch([order_by, sort_field], () => {
    getData(1)
})

watch(searchInfo, () => {
    getData(1)
}, { deep: true })

watch(hscodeList, () => {
    hscode_title.value = getHscodeTitle()
})

defineExpose({
    indicator_standard_list,
    drawRadarChart,
    order_by,
    sort_field,
    searchInfo
})
</script>
<template>
    <div class="card card1 px-3 py-2" style="width: 100%;border-radius: 0.55rem;">
        <div class="my-card-header">{{ props.title }}</div>
        <div class="my-card-content ">
            <div class="my-scroll-bar" style="flex: 1; max-height: calc(100% - 300px); display: flex;
             flex-direction: column;
             justify-content: space-between;
             overflow-y: auto;
             position: relative;
             ">
                <div>
                    <div class="hscode my-3 search">
                        <!-- <el-select @change="changeTemplate(1)" v-model="product_template_name" filterable clearable
                        :placeholder="getLangValue('dashboard.dataBaseType')" style="width: 100%; height: 38px;">
                        <el-option v-for="item in props.databaseList" :key="item.id" :label="item.name"
                            :value="item.name" />
                    </el-select> -->
                        <el-cascader style="width: 100%; height: 38px;" v-model="product_template_name"
                            :props="{ label: i18n.global.locale == 'en' ? 'label_en' : 'label' }"
                            :options="props.databaseList" :placeholder="getLangValue('dashboard.dataBaseType')"
                            @change="changeTemplate(1)" />
                    </div>
                    <!-- 搜索框 -->
                    <div class="search my-2 d-flex">
                        <!-- <el-cascader placeholder="HS Code" style="width: 110px; height: 38px;"
                        :props="{ label: 'title', value: 'id' }" :show-all-levels="false" v-model="hscode"
                        :options="hscodeList" filterable clearable class="" /> -->
                        <el-select v-model="hscode" filterable clearable class="me-2" placeholder="HS Code"
                            style="min-width: 110px; height: 38px;">
                            <el-option v-for="item in hscodeList" :key="item.value"
                                :label="i18n.global.locale == 'en' ? item.title_en : item.title" :value="item.id" />
                        </el-select>
                        <input clearable class="form-control mx-2" v-model="keyword" required
                            :placeholder="placeholder" />
                        <button type="button" class="btn btn-success" @click="search()" style="min-width: 93px;">
                            {{ getLangValue("base.search") }}
                        </button>
                    </div>
                    <div class="mt-3" style="text-align: center;border: 1px dashed white; height: 1px;"></div>
                    <!-- 图片二维码信息 -->
                    <div class="d-flex justify-content-between my-1" v-if="imageList.length">
                        <div class="d-flex justify-content-center "
                            style="background-color: white;width: 140px; height: 140px; border-radius: 4px;">
                            <img :src="imageList[0]" style="height: 140px; width: 140px;" class="cursor-pointer"
                                @click="showPicture">
                        </div>
                        <div style="height: 150px;">
                            <img :src="imageList[1]" style="height: 140px; width: 140px;">
                            <div style="text-align: center;font-size: 14px;color: #212529;">{{getLangValue('product-management', "code_pid_gtin")}}</div>
                        </div>
                        <div style="height: 150px;">
                            <img :src="imageList[2]" style="height: 140px; width: 140px;">
                            <div style="text-align: center;font-size: 14px;color: #212529;">{{getLangValue('product-management', "code_oid")}}</div>
                        </div>
                    </div>
                </div>
                <!-- 信息list -->
                <div class="fieldslist"
                    style="flex: 1; display: flex; justify-content: space-around; flex-direction: column;">
                    <div class="my-1" v-for="(item, k) in fieldsList" :key="k" style="font-size: 14px; color: #212529;"
                        :style="k == fieldsList.length - 1 ? { 'font-size': '14px', 'color': '#212529', 'position': 'relative' } : { 'font-size': '14px', 'color': '#212529', }">
                        <span :class="k > 6 ? 'chartField' : ''">
                            {{ item.name }} :
                            <template v-if="item.key == 'title'">
                                <span>
                                    {{ hscode_title || '-' }}
                                </span>
                            </template>
                            <template v-else-if="item.key == 'description'">
                                <span>
                                    {{ getdescprtion() || '-' }}
                                </span>
                            </template>
                            <template v-else-if="item.key == 'oid' || item.key == 'company_name'">
                                <span v-if="detailInfo.organization">{{ detailInfo.organization[item.key] || '-'
                                }}</span>
                                <span v-else>-</span>
                            </template>
                            <template v-else-if="item.key == 'pid'">
                                <span>{{ detailInfo[item.key] ? `FBD` + detailInfo[item.key] : '-'
                                }}</span>
                            </template>

                            <template v-else-if="item.key == 'place_of_origin'">
                                <span v-if="detailInfo.place_of_origin"
                                    :title="detailInfo.place_of_origin.name || '-'">{{
                                        detailInfo.place_of_origin.name || '-' }}</span>
                                <span v-else>-</span>
                            </template>

                            <template v-else-if="item.key == 'batch_size'">
                                <span>
                                    {{ getDetailInfo(item.key) || '-' }}
                                </span>
                            </template>
                            <template v-else-if="item.key == 'targetmarket'">
                                <span :title="getTargetmarket()">
                                    {{ getTargetmarket() }}
                                </span>
                            </template>
                            <template v-else-if="item.key == 'release_time'">
                                <span>
                                    {{ (detailInfo.release_time &&
                                        moment(detailInfo.release_time).format('YYYY-MM-DD')) || '-' }}
                                </span>
                            </template>
                            <span v-else :title="detailInfo[item.key]">{{ detailInfo[item.key] || '-' }}</span>

                        </span>
                        <div v-if="k == fieldsList.length - 1"
                            style="position: absolute; bottom: 0; right: 0; width: 300px;">
                            <div v-loading="loadingSankey">
                                <div style="height: 100px; width: 90%; padding-left: 20px;" id="small-chart"
                                    @click="showChart()"></div>
                                <div style="text-align: center;">
                                    <a @click="showChart()"
                                        style="color: #0AB39C; text-decoration: underline !important; cursor: pointer;">
                                        {{ getNameByCategory() }}
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
            <div style="height: 300px;">
                <div class="mt-2" style="text-align: center;border: 1px dashed #212529; height: 1px;"></div>
                <!-- 质量评级 -->
                <div class="rank mt-1" style="height: calc(100% - 1rem);">
                    <div class="d-flex justify-content-between h-100">
                        <!-- 2024-10-9新增图表 -->
                        <div style="min-width: 300px; flex: 6;height: 100%;position: relative;">
                            <el-popover placement="top-start" trigger="hover" width="200">
                                <template #reference>
                                    <i class=" ri-error-warning-fill"
                                        style="position: absolute; top: 30px;left:-10px;color:#5a6fc0; font-size: 20px;"></i>
                                </template>
                                <template #default>
                                    <div>
                                        <div id="rankInfo" class="display-inline">
                                            <div style="text-align: left;"> 0:
                                                <span v-if="props.category == 3">{{
                                                    getLangValue('dashboard.quality.titleText6')
                                                }}</span>
                                                <span v-else-if="props.category == 5">{{
                                                    getLangValue('dashboard.environment.titleText6') }}</span>
                                                <span v-else-if="props.category == 6">{{
                                                    getLangValue('dashboard.esg.titleText6')
                                                }}</span>
                                                <span v-else-if="props.category == 4">{{
                                                    getLangValue('dashboard.circularity.titleText6') }}</span>
                                                <span v-else-if="props.category == 2">{{
                                                    getLangValue('dashboard.comfort.titleText6') }}</span>
                                            </div>
                                            <div style="text-align: left;"> 1:
                                                <span v-if="props.category == 3">{{
                                                    getLangValue('dashboard.quality.titleText7')
                                                }}</span>
                                                <span v-else-if="props.category == 5">{{
                                                    getLangValue('dashboard.environment.titleText7') }}</span>
                                                <span v-else-if="props.category == 6">{{
                                                    getLangValue('dashboard.esg.titleText7')
                                                }}</span>
                                                <span v-else-if="props.category == 4">{{
                                                    getLangValue('dashboard.circularity.titleText7') }}</span>
                                                <span v-else-if="props.category == 2">{{
                                                    getLangValue('dashboard.comfort.titleText7') }}</span>
                                            </div>
                                        </div>

                                    </div>
                                </template>
                            </el-popover>
                            <div
                                style="height: 20px;font-size: 0.7vw; font-weight: 700; color: #212529; text-align: center">
                                {{ props.title1 }}</div>
                            <div style="width: 100%; height: 210px; position: absolute; bottom: 30px;"
                                v-loading="loadingRadar">
                                <div v-show="radarHasData" id="index_standard_chart" @click="showBigChart"
                                    style="width: 100%; height: 100%;"></div>
                                <Empty v-if="!radarHasData"></Empty>
                            </div>
                        </div>
                        <div v-show="showInstand" style=" height: 100%;  min-width: 40px; max-width: 200px; flex: 4;">
                            <div style=" height: 100%;  width: 100%;">
                                <div @click="showInstand = false" class="cursor-pointer"
                                    :class="i18n.global.locale == 'en' ? 'en-word-break' : 'zh-word-break'"
                                    style="min-height: 20px;font-size: 0.7vw; font-weight: 700; color: #212529;text-align: center; word-break: break-all;">
                                    {{ props.title2 }}</div>
                                <div style=" max-width: 200px;height: calc(100% - 30px); text-align: left; overflow-y: auto; overflow-x: hidden; border-left: 1px dashed #212529;"
                                    class="d-flex flex-column  flex-1 ps-1 my-scroll-bar">
                                    <div class="my-1 d-flex align-items-center "
                                        v-for="(item, k) in indicator_standard_list" :key="k"
                                        style="text-align: left; flex-wrap: wrap; max-width: 200px; ">
                                        <!-- {{ getLangValue("dashboard.quality.special_indicators") }}：1度1111141414 -->
                                        <div style="text-align: left; max-width: 200px; word-break: break-all; ">{{
                                            i18n.global.locale == 'en' ?
                                                item.index_standard?.name_en : item.index_standard?.name }}:</div>
                                        <div style="text-align: left; max-width: 200px;word-break: break-all;  ">
                                            {{ item.value }}{{ i18n.global.locale == 'en' ?
                                                item.index_standard?.unit_en ? `(${item.index_standard?.unit_en})` : '' :
                                                item.index_standard?.unit ? `(${item.index_standard?.unit})` : '' }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 图标 -->
                        <i class="ri-arrow-left-s-line mx-2 cursor-pointer" style="font-size: 24px;"
                            v-show="!showInstand" @click="showInstand = true"></i>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <!-- 弹框展示图表 -->
    <myDailog v-if="visible" v-model:visible="visible" :title="title" :width="800">
        <div style="font-weight: bold;">{{ getSankeyTitle() }}</div>
        <div style="width: 100%; height: 500px;" ref="myChartsRef"></div>
        <div class="d-flex mt-2 justify-content-between flex-wrap">
            <!-- <div style="width: 30%; font-size: 12px; text-align: left;" v-for="(item, key) in nodeDataList" :key="key"
                class="m-2">
                <b>{{ item.name }}</b>:{{ item.pid }}
                <div v-if="item.value != null && props.category == 5"><b>{{ getLangValue('dashboard.total_pef') }}</b>:{{
                    item.value
                    }}</div>
                <div v-if="item.value != null && props.category == 6"><b>{{ getLangValue('dashboard.total_esg') }}</b>:{{
                    item.value
                    }}</div>
                <div v-if="item.value != null && props.category == 4"><b>{{ getLangValue('dashboard.total_circularity') }}</b>:{{
                    item.value }}</div>
            </div> -->
        </div>
    </myDailog>
    <PreviewImg v-model:showPreviewImg="showPreviewImg" :srcList="srcList" :myWidth="400" v-if="showPreviewImg">
    </PreviewImg>
</template>
<style scoped lang="scss">
// .card {
//     background-color: #495057;
//     border: 1px solid #D9D9D980;
//     height: calc(100% - 1.3rem);

//     .my-card-header {
//         color: white;
//         font-size: 16px;
//         font-weight: 700;
//     }

//     .my-card-content {
//         height: calc(100% - 24px);
//         display: flex;
//         flex-direction: column;

//         .hscode {
//             color: #9599AD;
//             word-break: break-all;

//             .active {
//                 color: white !important;
//             }
//         }

//         .search {
//             height: 38px;

//             :deep(.el-select__selected-item) {
//                 color: white;
//             }

//             :deep(.el-select__wrapper) {
//                 background-color: #4a5056;
//                 height: 100%;
//             }

//             :deep(.el-select__placeholder.is-transparent) {
//                 color: #889AA5 !important;
//             }

//             :deep(.el-input--suffix) {
//                 width: 110px;
//                 height: 100%;
//             }

//             :deep(.el-input__wrapper) {
//                 background-color: #4a5056;
//             }

//             :deep(.el-input__inner) {
//                 color: white;
//             }

//             .form-control {
//                 background-color: #4a5056;
//                 color: white;
//             }
//         }
//     }
// }

.card1 {
    // background-color: #495057;
    border: 1px solid #D9D9D980;
    // height: calc(100% - 1.3rem);

    .my-card-header {
        color: #212529;
        font-size: 16px;
        font-weight: 700;
    }

    .my-card-content {
        height: calc(100% - 24px);
        display: flex;
        flex-direction: column;

        .hscode {
            color: #9599AD;
            word-break: break-all;

            .active {
                color: white !important;
            }
        }

        .search {
            height: 38px;

            :deep(.el-select__selected-item) {
                font-size: 0.8125rem;
                color: #212529;
            }

            :deep(.el-select__wrapper) {
                // background-color: #4a5056;
                height: 100%;
            }

            :deep(.el-select__placeholder.is-transparent) {
                font-size: 0.8125rem;
                color: #878a99 !important;
            }

            :deep(.el-cascader .el-input__inner) {
                &::placeholder {
                    font-size: 0.8125rem;
                    color: #878a99 !important;
                }
            }

            :deep(.el-select__selected-item.el-select__placeholder) {
                font-size: 0.8125rem;
                color: #212529;
            }

            :deep(.el-cascader .el-input--suffix) {
                width: 100% !important;
            }

            :deep(.el-input--suffix) {
                width: 110px;
                height: 100%;
            }

            // :deep(.el-input__wrapper) {
            //     // background-color: #4a5056;
            // }

            :deep(.el-input__inner) {
                font-size: 0.8125rem;
                color: #212529;
            }

            .form-control {
                // background-color: #4a5056;
                color: #212529;
            }
        }

        .rank {
            .ball {
                background-color: #0AB39C;
                min-width: 15px !important;
                height: 15px;
                border-radius: 15px;
            }
        }
    }
}

.active {
    color: #889AA5 !important;
}

.chartField {
    width: 160px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
<style>
.active.el-dropdown-menu__item {
    color: #409eff;
}

.el-tooltip__trigger:focus {
    outline: none;
}
</style>
